// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Redline processing node registration.
 */
import { registerPipelineNode } from '../../../core/pipeline-registry'
import { RedlineAdminView } from './components/AdminView'
import { RedlineWorkflowNode } from './components/WorkflowNode'

registerPipelineNode({
  id: 'processing.redline',
  manifest: {
    id: 'processing.redline',
    name: 'Redline',
    category: 'processing',
    icon: 'Highlighter',
    description: 'Highlight findings from upstream analysis results onto page PDFs',
    order: 20,
  },
  WorkflowNode: RedlineWorkflowNode,
  AdminConfig: RedlineAdminView,
})
